import { Backdrop, Button, Stack } from '@mui/material'
import React, { useState } from 'react'

const options = [
    "List top 10 movies of 2019: Title - imdb rating",
    "How tall is the Eiffel Tower?",
    "Generate a poem about an elephant",
    "List top 5 countries by their GDP: Country - GDP",
    "The capital of Canada is",
]
const InputSelect = ({ setPrompt }) => {
    const [backdropOpen, setBackdropOpen] = useState(false)
    const handleClick = (e) => {
        setPrompt(e.target.value)
    }
    return (
        <>
            <Button onClick={() => setBackdropOpen(state => !state)}>
                or use a sample prompt
            </Button>
            <Backdrop
                open={backdropOpen}
                onClick={() => setBackdropOpen(false)}
                sx={{ zIndex: 2 }}
            >
                <Stack
                    direction='column'
                    gap={1}
                    sx={{ p: 2, bgcolor: 'background.paper', opacity: 1 }}
                >
                    {options.map(optionName => (
                        <Button key={optionName} fullWidth variant='contained' color='warning' onClick={handleClick} value={optionName}>
                            {optionName}
                        </Button>
                    ))}
                </Stack>

            </Backdrop>
        </>
    )
}

export default InputSelect